import { createEmptyFetchable } from 'helpers/loadableHelpers'
import { Reducer } from 'interfaces'
import { CCOnboardingInitiateAction } from 'components/features/creditCard/creditCardStore/actions'
import { CreditCardAppState } from 'components/features/creditCard/creditCardStore/state'

const INITIAL_STATE = createEmptyFetchable<null>()
export const initiateRequestReducer: Reducer<CreditCardAppState['initiateRequest']> = (prevState = INITIAL_STATE, action) => {
  switch (action.type) {
    case CCOnboardingInitiateAction.type: {
      if (action.meta === 'request') {
        return {
          isLoading: true,
          errorCode: null,
          data: null,
        }
      }

      if (action.meta === 'fail') {
        return {
          ...prevState,
          isLoading: false,
          errorCode: action.payload.errorCode,
          errorsMap: action.payload.errorsMap,
        }
      }

      return {
        isLoading: false,
        errorCode: null,
        data: null,
      }
    }
  }
  return prevState
}
